import InView from '@v4/common/components/atoms/InView/InView';

export default InView;
